var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("×")]),_c('h3',[_vm._v("Detalles de No Entregados")]),_c('div',{staticClass:"table-container"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.noEntregadosData,"pagination-options":{
          enabled: true,
          mode: 'pages',
          nextLabel: 'Siguiente',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'Página',
          allLabel: 'Todo',
        },"search-options":{
          enabled: true,
          placeholder: 'Buscar',
        },"line-numbers":true}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }